export default class extends Controller {
  static targets = ['categorySelect', 'subcategorySelect'];

  connect() {
    App.DynamicSelect.onChange(this.categorySelectTarget, this.setSubcategorySelect.bind(this));
    this.disableSubcategories();
  }

  setSubcategorySelect() {
    const subSelect = $(this.subcategorySelectTarget);
    subSelect.select2('val', null);
    subSelect.data('select2-ajax-url', `/${this.companyID}/product_categories/product_subcategories_search?product_category_id=${this.categoryID}`);
    this.disableSubcategories();
  }

  disableSubcategories() {
    var enable = $(this.categorySelectTarget).val() ? true : false;
    $(this.subcategorySelectTarget).select2('enable', enable);
  }

  //
  // GETTERS AND SETTERS
  //

  get companyID() {
    return this.data.get('company-id') || '0000000';
  }

  get categoryID() {
    return this.categorySelectTarget.value;
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/product-category-select-controller.js